var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTeamIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9641 6.60662L3.92031 1.10505C3.90191 1.09056 3.87979 1.08156 3.8565 1.07907C3.8332 1.07659 3.80968 1.08072 3.78863 1.091C3.76758 1.10128 3.74986 1.11729 3.7375 1.13719C3.72514 1.15709 3.71864 1.18007 3.71875 1.20349V2.4113C3.71875 2.48787 3.75469 2.5613 3.81406 2.60818L9.43906 7.00037L3.81406 11.3926C3.75313 11.4394 3.71875 11.5129 3.71875 11.5894V12.7972C3.71875 12.9019 3.83906 12.9597 3.92031 12.8957L10.9641 7.39412C11.0239 7.34742 11.0724 7.28768 11.1057 7.21945C11.139 7.15122 11.1563 7.07629 11.1563 7.00037C11.1563 6.92444 11.139 6.84951 11.1057 6.78128C11.0724 6.71305 11.0239 6.65332 10.9641 6.60662Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTeamIcon);
export default __webpack_public_path__ + "static/media/arrowTeamIcon.6fe42ac070d0ec6c31107cd5789373ce.svg";
export { ForwardRef as ReactComponent };